import { createRouter } from "@tanstack/react-router"

import { routeTree } from "./routeTree.gen"
import { RoutePending } from "./components/RoutePending"

export const router = createRouter({
  routeTree,
  // Prefetch a route's chunk on hover/touch intent. The create/* routes pull 480-510 KB cold;
  // without this the click is a bare waterfall. Imperative nav (the two-tier sidebar) calls
  // `router.preloadRoute` directly — intent preload only fires for <Link>.
  defaultPreload: "intent",
  defaultPreloadDelay: 50,
  // Route data is owned by tRPC/React Query, not route loaders, so preloaded matches can stay
  // fresh for a while — this only gates loader re-runs, not query freshness.
  defaultPreloadStaleTime: 30_000,
  defaultPendingComponent: RoutePending,
  defaultPendingMs: 200,
  defaultPendingMinMs: 300,
})

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
